import React from "react";
import { RollOverRequestsPendingApprovalConainer } from "../../../containers";

const RollOverRequestsPendingApproval = (props) => {
  return <RollOverRequestsPendingApprovalConainer {...props} />;
};

export default RollOverRequestsPendingApproval;
